import React from 'react';

const LiveMessageContext = React.createContext();

export default LiveMessageContext;
